import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getOurCulturePhotos , gotSkillListingFailure} from "../actions";
import { getUserSkillListingApi,getPerUserSkillListingApi,getGuestUserSkillListingApi,skillListingTotalCountApi,skillListingCountSagaApi, fetchSearchDisciplineAPI , fetchSearchSkillAPI } from "../../API/API";

const normalizeGuestSkillListing = (data) => ({
  ...data,
  skill_listings: Array.isArray(data?.skill_listings)
    ? data.skill_listings[0] || null
    : data?.skill_listings,
});

function* getCandidateSkillListingSaga(id) {
 
  try {
    const response = yield call(() => getUserSkillListingApi(id)); // API Backend
    yield put({ type: types.GET_CANDIDATE_SKILLLISTING_SUCCESS, payload: response.data });
    // `/skill/listing?type=Published&userId=${".data.skilllisting._id"}`
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_CANDIDATE_SKILLLISTING_FAILURE, error });
  }
}

function* getPerUserSkillListing(action) {
 
  try{
    const fetchSkillListing = action.payload?.useGuestEndpoint
      ? getGuestUserSkillListingApi
      : getPerUserSkillListingApi;
    const response = yield call(() => fetchSkillListing(action.payload));
    const payload = action.payload?.useGuestEndpoint
      ? normalizeGuestSkillListing(response.data)
      : response.data;
    yield put({type:types.GET_ONE_USER_SKILLLISTING_SUCCESS, payload});
  }
  catch(error){
    yield put({ type: types.GET_ONE_USER_SKILLLISTING_FAILURE, error });
  }
}

function* skillListingCountSaga(params) {
  try {
    const response = yield call(() => skillListingCountSagaApi(params));
    if (response)
      yield put({
        type: types.SKILL_LISTING_COUNT_SUCCESS,
        payload: response.data,
      });
    else {
      yield put({ type: types.SKILL_LISTING_COUNT_FAILURE, error:true });
    }
  } catch (error) {}
}

//skilllisting total count saga
function* skillListingTotalCountSaga(params) {
  try {
    const response = yield call(() => skillListingTotalCountApi(params));
    if (response)
      yield put({
        type: types.SKILL_LISTING_TOTALCOUNT_SUCCESS,
        payload: response.data,
      });
    else yield put({ type: types.SKILL_LISTING_TOTALCOUNT_FAILURE, error:true });
  } catch (error) {
    yield put({ type: types.SKILL_LISTING_TOTALCOUNT_FAILURE, error });
  }
}

function* fetchKeySearchDiscipline(params) {
  try {
    const response = yield call(fetchSearchDisciplineAPI, params); // API Backend
    yield put({
      type: types.FETCH_SEARCH_DISCIPLINE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.warn(error);
    yield put(gotSkillListingFailure(error));
  }
}

function* fetchKeySearchSkill(params) {
  try {
    const response = yield call(fetchSearchSkillAPI, params); // API Backend
    yield put({
      type: types.FETCH_SEARCH_DISCIPLINE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.warn(error);
    yield put(gotSkillListingFailure(error));
  }
}


export function* watchGetCandidateSkillListing() {
  yield takeEvery(types.GET_CANDIDATE_SKILLLISTING, getCandidateSkillListingSaga);
}

export function* watchSkillListingCountSaga() {
  yield takeEvery(types.SKILL_LISTING_COUNT_INIT, skillListingCountSaga);
}

export function* watchSkillListingTotalCountSaga() {
  yield takeEvery(types.SKILL_LISTING_TOTALCOUNT_INIT, skillListingTotalCountSaga);
}

export function* watchKeySearchDiscipline() {
  yield takeEvery(types.FETCH_SEARCH_DISCIPLINE_INIT, fetchKeySearchDiscipline);
}

export function* watchKeySearchSkill() {
  yield takeEvery(types.FETCH_SEARCH_DISCIPLINE_INIT, fetchKeySearchSkill);
}

export function* watchPerUserSkillListingSaga(){
  yield takeEvery(types.GET_ONE_USER_SKILLLISTING_REQUESTED, getPerUserSkillListing);
}
